import React from "react";
import { formatIDR } from "../../../utils/helpers/formatIDR";
import ItemAvatar from "../../../components/ItemAvatar";

const formatQty = (value) =>
  Number(value || 0).toLocaleString("id-ID", {
    maximumFractionDigits: 4,
  });

const Metric = ({ label, value, tone = "" }) => (
  <div className={`dashboard-sold-detail-metric ${tone}`.trim()}>
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

const SoldProductDetailModal = ({ product, detail, loading, error, rangeLabel, onClose }) => {
  if (!product) return null;

  const metrics = detail?.metrics || {};
  const materials = detail?.materials || [];

  return (
    <div
      className="modal modal-blur show d-block dashboard-sold-detail-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dashboard-sold-detail-title"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.3)", zIndex: 1090 }}>
      <div className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header dashboard-sold-detail-header">
            <div className="dashboard-sold-detail-identity">
              <ItemAvatar
                name={detail?.product?.display_name || product?.name || "Produk"}
                image={detail?.product?.image || product?.image}
                size="lg"
              />
              <div>
                <span className="dashboard-sold-detail-eyebrow">DETAIL PRODUK TERJUAL</span>
                <h3 className="modal-title" id="dashboard-sold-detail-title">
                  {detail?.product?.display_name || product?.name || "Produk"}
                </h3>
                <p>{rangeLabel}</p>
              </div>
            </div>
            <button type="button" className="btn-close" aria-label="Tutup" onClick={onClose} />
          </div>

          <div className="modal-body dashboard-sold-detail-body">
            {loading ? (
              <div className="dashboard-sold-detail-loading">
                <span className="spinner-border text-primary" role="status" aria-label="Memuat detail produk" />
                <p>Menyiapkan performa produk dan pemakaian material…</p>
              </div>
            ) : error ? (
              <div className="alert alert-danger mb-0">{error}</div>
            ) : (
              <>
                <div className="dashboard-sold-detail-metrics">
                  <Metric label="Jumlah terjual" value={`${formatQty(metrics?.total_qty)} ${detail?.product?.unit || "pcs"}`} />
                  <Metric label="Harga rata-rata setelah diskon" value={formatIDR(metrics?.average_price)} />
                  <Metric label="HPP rata-rata" value={formatIDR(metrics?.average_cogs)} />
                  <Metric label="Laba kotor" value={formatIDR(metrics?.gross_profit)} tone="is-highlight" />
                </div>

                <section className="dashboard-sold-detail-summary">
                  <div>
                    <span>Total Penjualan</span>
                    <strong>{formatIDR(metrics?.total_sales)}</strong>
                  </div>
                  <div>
                    <span>Total HPP</span>
                    <strong>{formatIDR(metrics?.total_cogs)}</strong>
                  </div>
                  <div>
                    <span>Margin kotor</span>
                    <strong>{formatQty(metrics?.gross_margin)}%</strong>
                  </div>
                  <div>
                    <span>Transaksi</span>
                    <strong>{formatQty(metrics?.transaction_count)}</strong>
                  </div>
                </section>

                <section className="dashboard-material-usage-card">
                  <div className="dashboard-material-usage-heading">
                    <div>
                      <h4>Material yang terpakai</h4>
                      <p>
                        {detail?.material_source === "ledger"
                          ? "Berdasarkan mutasi stok aktual dari transaksi pada periode ini."
                          : "Estimasi dari resep aktif karena transaksi lama belum menyimpan relasi material per produk."}
                      </p>
                    </div>
                    <span className={`badge ${detail?.material_source === "ledger" ? "bg-success-lt text-success" : "bg-warning-lt text-warning"}`}>
                      {detail?.material_source === "ledger" ? "Ledger aktual" : "Estimasi resep"}
                    </span>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-vcenter mb-0">
                      <thead>
                        <tr>
                          <th>Material</th>
                          <th className="text-end">Per produk</th>
                          <th className="text-end">Total terpakai</th>
                          <th className="text-end">Stok saat ini</th>
                        </tr>
                      </thead>
                      <tbody>
                        {materials.length ? (
                          materials.map((material, index) => (
                            <tr key={`${material?.material_id}-${index}`}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <ItemAvatar
                                    name={material?.material_name || "Material"}
                                    image={material?.image_path || material?.image}
                                    size="sm"
                                  />
                                  <div>
                                    <strong>{material?.material_name || "Material"}</strong>
                                    <small className="d-block text-secondary">{material?.category_label || material?.category || "Bahan baku"}</small>
                                  </div>
                                </div>
                              </td>
                              <td className="text-end">
                                {formatQty(material?.usage_per_product)} {material?.unit || ""}
                              </td>
                              <td className="text-end fw-bold text-danger">
                                {formatQty(material?.total_used)} {material?.unit || ""}
                              </td>
                              <td className="text-end">
                                {formatQty(material?.current_stock)} {material?.unit || ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center text-secondary py-5">
                              Produk ini tidak menggunakan material atau belum mempunyai resep.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </section>
              </>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-primary px-4" onClick={onClose}>
              Selesai
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoldProductDetailModal;
